<template>
  <div class="button-group">
    <!--免费-->
<!--    <template v-if="form.sellType == 1">-->
<!--      <ButtonImgText-->
<!--          v-if="form.collectFlag == 0"-->
<!--          @handleClick="collectCourse(1)"-->
<!--          minWidth-->
<!--          logo="./img/collect.png"-->
<!--          text="收藏"-->
<!--      />-->
<!--      <ButtonImgText-->
<!--          v-else-if="form.collectFlag == 1"-->
<!--          @handleClick="collectCourse(0)"-->
<!--          minWidth-->
<!--          logo="./img/collect_act.png"-->
<!--          text="已收藏"-->
<!--      />-->
<!--    </template>-->
    <!--付费-->
    <template v-if="form.sellType == 2">
      <ButtonImgText
          @handleClick="customerService"
          logo="./img/kf.png"
          text="课程咨询"
      />
<!--      <template v-if="!isSVipCourse">-->
<!--        <ButtonImgText-->
<!--            v-if="form.collectFlag == 0"-->
<!--            @handleClick="collectCourse(1)"-->
<!--            minWidth-->
<!--            logo="./img/collect.png"-->
<!--            text="收藏"-->
<!--        />-->
<!--        <ButtonImgText-->
<!--            v-else-if="form.collectFlag == 1"-->
<!--            @handleClick="collectCourse(0)"-->
<!--            minWidth-->
<!--            logo="./img/collect_act.png"-->
<!--            text="已收藏"-->
<!--        />-->
<!--      </template>-->
      <ButtonImgText
          v-if="form.auditionFlag && form.payType == 0"
          @handleClick="trialStudy"
          logo="./img/sx.png"
          text="试学"
      />
    </template>


    <template>
      <Appointment
          @ok="$emit('update')"
          :form="form"
          v-if="form.courseButtonType == 10||
          form.courseButtonType == 11||form.courseButtonType == 12
          ||form.courseButtonType == 13||form.courseButtonType == 14"
      />
<!--      有学习权限-->
      <template v-else-if="form.courseButtonType == 7">
        <div
            v-if="isSVipCourse"
            @click="toLearn"
            class="group-vanbtn s-vip"
        >
          <span class="s-vip-t">去学习</span>
          <span class="s-vip-tip">会员可免费学习本节课程</span>
        </div>
        <VanButton
            v-else
            @click="toLearn"
            class="group-vanbtn"
        >去学习</VanButton>
      </template>
      <VanButton
          v-else-if="form.courseButtonType == 2"
          @click="freeSubscribe"
          class="group-vanbtn"
      >
        免费学习
      </VanButton>
      <div
          v-else-if="form.courseButtonType == 3"
          @click="freeSubscribe"
          class="van-button van-button--default van-button--normal group-vanbtn"
      >
        限时免费
        <del class="deltip">原价￥{{ form.sellPriceCNY }}</del>
      </div>
      <template v-else-if="hasCourseAuth">
        <div
            @click="toLearn"
            class="group-vanbtn s-vip"
        >
          <span class="s-vip-t">去学习</span>
          <span class="s-vip-tip">会员可免费学习本节课程</span>
        </div>
      </template>
      <template
          v-else-if="
          form.courseButtonType == 1 ||
          form.courseButtonType == 4 ||
          form.courseButtonType == 5 ||
          form.courseButtonType == 6
        "
      >
        <SVipBtn
            v-if="isSVipCourse"
            :form="form"
            @buy="has=>buyCourse(has)"
        />
        <Coupon
            v-else
            :form="form"
            :labelName="labelName"
            @buy="has=>buyCourse(has)"
        />
      </template>
    </template>

  </div>
</template>
<script>
import ButtonImgText from "./ButtonImgText.vue";
import {Toast, Button as VanButton, CountDown} from "vant";
import {subscibe, getCourseValidityInfo, receiveCourseCoupon} from "@/api/coursePack.js";
import {collection} from "@/api/collect.js";
import {
  gotoNative,
  dataBuryingPoint,
  goRefresh
} from "@/utils/JSBridge.js";
import {VersionVerification} from "@/utils/versionCompare.js";
import {iosAppIsReview} from "@/utils/app.js";
import Config from "@/config/app.js";
import Telephone from "../../../components/Telephone/Telephone.vue";
import Coupon from "./Coupon.vue"
import Appointment from "./Appointment.vue";
import SVipBtn from "./SVipBtn.vue"
import {getAngelVipUserBaseInfoAll, getSuperVipUserBaseInfo} from "@/api/angelVipInfo";

export default {
  name: "GroupButtons",
  components: {Appointment, ButtonImgText, VanButton, Telephone, Coupon,SVipBtn, CountDown},
  props: {
    courseId: String,
    labelName: String,
    form: {
      type: Object,
      default: () => {
      }
    },
    isVipCourse: [Boolean, Number]
  },
  data() {
    return {
      isSVip:false,//是超级会员
      hasCourseAuth:false,//通过会员对应的课程会员判断是否有权限
      hadClickCollect: true, // 可以点击收藏
    };
  },
  computed: {
    isSVipCourse() {
      let vipList = this.form.vipGroupTypeList
      return Array.isArray(vipList) && vipList.includes(6);
    }
  },
  methods: {
    customerService() {
      // 客服
      gotoNative("nurse://weixin.kf?url=https://work.weixin.qq.com/kfid/kfcfb26ee166a623add")
      setTimeout(() => {
        dataBuryingPoint("B000005", "B000005-001", {
          id: this.courseId,
          name: this.form.name
        });
      }, 300);
    },
    collectCourse(val) {
      // 收藏=1/取消收藏=0
      if (!this.hadClickCollect) return;
      this.hadClickCollect = false;
      collection({id: this.courseId, type: 2, state: val})
          .then(r => {
            let message = val == 1 ? "收藏成功" : "已取消收藏";
            Toast(message);
            this.$emit("update");
            goRefresh("refresh_collection_list");
            this.hadClickCollect = true;
          })
          .catch(() => {
            this.hadClickCollect = true;
          })
          .finally(() => {
            setTimeout(() => {
              dataBuryingPoint("B000005", "B000005-007", {
                id: this.courseId,
                name: this.form.name
              });
            }, 300);
          });
    },
    freeSubscribe() {
      // 免费订阅
      setTimeout(() => {
        dataBuryingPoint("B000005", "B000005-004", {
          id: this.courseId,
          name: this.form.name
        });
      }, 300);
      if (this.form.useFlag == 0) {
        Toast("该课程已下架");
        return;
      }
      subscibe({courseId: this.courseId, subscibeFlag: 1})
          .then(r => {
            Toast("已成功订阅!");
            this.$emit("update");
          })
          .catch(() => {
          });
    },
    trialStudy() {
      // 试学
      let nurseUrl = `nurse://study.course.detail.try?operateCourseId=${this.courseId}`;
      dataBuryingPoint("B000005", "B000005-006", {
        id: this.courseId,
        name: this.form.name
      });
      setTimeout(() => {
        gotoNative(nurseUrl);
      }, 300);
    },
    toLearn() {
      setTimeout(()=>{
        dataBuryingPoint("BX00010", "BX00010-004", {
          id: this.courseId,
          name: this.form.name
        });
      },500)
      /**
       *  去学习
       *  courseType //==1 原子课==2课程包
       *  frozenFlag //==1 跳转课程冻结页面
       *  pastDueFlag //==1 跳转课程过期页面
       *  assistType //==1 跳转课程包页面
       *  operateCourseId // 运营课程包名称
       *  coursePackageId // 教研课程包id
       *  atomicCourseId // 原子课id
       *  knowledgeId // 知识点id
       *  courseName // 教研课程包名称
       * recentlyFlag // 1有最近学习0从未学习
       *
       */
      if (this.form.useFlag == 0) {
        Toast("该课程已下架");
        return;
      }
      if (this.form.comboFlag == 1) {
        // 套餐课程进入我的课程
        gotoNative("nurse://study.my.course");
        return;
      }
      if (VersionVerification("5.1.6")) {
        let studyVo = this.form.recentlyStudyVO || {};
        let params = {
          courseType: this.form.courseType,
          assistType: this.form.assistType,
          courseName: this.form.name || "",
          atomicCourseId: studyVo.atomicCourseId || "",
          coursePackageId: studyVo.coursePackageId || "",
          knowledgeId: studyVo.knowledgeId || "",
          recentlyFlag: studyVo.recentlyFlag
        };
        getCourseValidityInfo({id: this.courseId})
            .then(r => {
              params.pastDueFlag = r.pastDueFlag;
              params.frozenFlag = r.frozenFlag;
              params.operateCourseId = r.operateCourseId;

              let regStr = "?";
              for (let v in params) {
                regStr = regStr + v + "=" + params[v] + "&";
              }
              let nurseUrl = "nurse://course.check.myCourse" + regStr;
              gotoNative(nurseUrl);
            })
            .catch(() => {
            });
      } else {
        gotoNative("nurse://study.my.course");
      }
    },
    goSettlement() {
      setTimeout(() => {
        //gotoNative(`nurse://otherLink?url=${Config.couponUrl}/settlement.html?courseId=${this.courseId}`)
        if (iosAppIsReview()) {
          gotoNative("nurse://course.buy?courseId=" + this.courseId);
        } else {
          gotoNative(
              `nurse://otherLink?url=${
                  Config.couponUrl
              }/settlement.html?courseId=${this.courseId}&isVipCourse=${
                  this.isVipCourse ? "1" : "0"
              }`
          );
        }
      }, 300);
    },
    buyCourse(hasCourseCoupon = false) {
      // 购买
      dataBuryingPoint("B000005", "B000005-002", {
        id: this.courseId,
        name: this.form.name
      });
      if (this.form.useFlag == 0) {
        Toast("该课程已下架");
        return;
      }
      if (hasCourseCoupon) {
        receiveCourseCoupon(this.courseId).then(() => {
          this.goSettlement()
        }).catch(() => {
          this.goSettlement()
        })
      } else {
        this.goSettlement()
      }
    }
  },
  watch: {
    form: function () {
      if(!Array.isArray(this.form.vipGroupTypeList)){
        return
      }
      if(this.form.vipGroupTypeList.length === 0){
        return
      }
      getAngelVipUserBaseInfoAll().then(r=>{
        console.log(r)
        if(!Array.isArray(r)){
          return
        }
        //遍历用户所拥有的全部会员，当会员状态有效并且此会员类型在课程会员列表中存在，则hasCourseAuth为true
        r.forEach(item=>{
          if(this.form.vipGroupTypeList.includes(item.vipGroupType) && item.userVipStatus === 1){
            this.hasCourseAuth = true
          }
        })

      })
    }
  },
  mounted() {
    getSuperVipUserBaseInfo().then(r=>{
      this.isSVip = r.userVipStatus  ===1
    })
  }
};
</script>

<style lang="scss" scoped>
.button-group {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgba(243, 245, 249, 1);
  padding: 0 15px;
  background: #ffffff;

  //box-sizing: border-box; /* 确保 padding 不会影响整体高度 */
  .btn-img {
    margin-right: 20px;
  }

  .group-vanbtn {
    flex: 1;
    height: 40px;
    background: linear-gradient(
            -58deg,
            rgba(255, 102, 102, 1) 0%,
            rgba(255, 68, 68, 1) 100%
    );
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 0;

    span {
      margin-top: 2px;
    }

    .deltip {
      display: block;
      font-size: 10px;
      font-weight: normal;
      margin-top: 16px;
    }
  }
  .s-vip{
    background: #FED690;
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: unset;
    .s-vip-t{
      font-size: 16px;
      color: #72391C;
      font-weight: 700;
    }
    .s-vip-tip{
      font-size: 14px;
      color: #813824;
      font-weight: 400;
    }

  }

  .group-vanbtn-count {
    height: 50px;
    border-radius: 25px;
    line-height: normal;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .count {
      font-size: 14px;
    }
  }
}
</style>
